const reducer = (state={date:1}, action) => {
     switch (action.type) {
        case 'REFRESH':
            return {
                ...state,
                contador: state.contador + 1
            }
        case 'TOGGLE':
            return {
                ...state,
                isOpen: action.payload
            }
        default:
            return state;
    }
}

export default reducer;
